import { Alert, Button } from 'antd';
import { ErrorBoundary as ErrorHandler, FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

type Props = {
  children: React.ReactNode;
};

const Fallback: React.FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
  const { t } = useTranslation();
  return (
    <Alert
      type="error"
      message={t('SOMETHING_WENT_WRONG')}
      description={error?.message ?? t('UNKNOW_ERROR')}
      action={<Button onClick={resetErrorBoundary}>{t('RELOAD_COMPONENT')}</Button>}
    />
  );
};

export const ErrorBoundary: React.FC<Props> = ({ children }) => {
  return <ErrorHandler FallbackComponent={Fallback}>{children}</ErrorHandler>;
};
